module.exports = __webpack_public_path__ + "static/media/profile-jon-stona.ed2af53f.png";